import React from "react";
import { Dialog } from "@toddle-edu/ds-web";

const ConformationModal = ({
  isConfirmationModalOpen,
  t,
  onCancelDiscardingChanges,
  onDiscardingChanges,
}) => {
  return isConfirmationModalOpen ? (
    <Dialog
      isOpen={true}
      title={t("common:discard_changes")}
      message={t("common:dicard_the_changes_warning_msg")}
      buttonOneText={t("common:agree_cancel")}
      buttonTwoText={t("common:action_agree", {
        action: t("common:discard"),
      })}
      onButtonOneClick={onCancelDiscardingChanges}
      onButtonTwoClick={onDiscardingChanges}
      onClose={onCancelDiscardingChanges}
      dsVersion={"2.0"}
    />
  ) : null;
};

export default ConformationModal;
